import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../lib/useTheme";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-pressed={isDark}
      className="inline-flex size-11 items-center justify-center rounded-lg text-ink-soft transition hover:bg-surface-2 hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      {isDark ? <Sun className="size-5" aria-hidden="true" /> : <Moon className="size-5" aria-hidden="true" />}
    </button>
  );
}
